/* eslint-disable implicit-arrow-linebreak */
import React from 'react';
import PropTypes from 'prop-types';
import { Label, MultiColumnList, NoValue } from '@folio/stripes-components';
import { FormattedMessage, useIntl } from 'react-intl';
import HelpeModal from '../../../../../shared/HelpeModal';
import { FieldsListColumnMapping } from '../../../../../constants';

const propTypes = {
  sectionFields: PropTypes.arrayOf(PropTypes.object),
};

function SectionFieldsList({ sectionFields }) {
  const intl = useIntl();

  const fieldLabelFormatter = (field) => {
    return (
      <Label>
        {field.label.find((locale) => locale.locale === intl.locale)?.value}
      </Label>
    );
  };

  const schemaFormatter = (field) => {
    return (
      <FormattedMessage
        id={`ui-plugin-inventory-templates.templateView.sectionFieldsList.column.schema.${field.schema}`}
        defaultMessage={field.schema}
      />
    );
  };

  const defaultValueFormatter = (field) => {
    if (field.type !== 'select') {
      return <NoValue />;
    }

    return field.fieldDataOption
      .find((opt) => opt.value === field.defaultValue)
      ?.label?.find((lab) => lab?.locale === intl.locale)?.value;
  };

  const infoModalFormatter = (field) => {
    return (
      <HelpeModal
        fieldData={field}
        title={
          field.label.find((locale) => locale.locale === intl.locale)?.value
        }
        iconSize="medium"
      />
    );
  };

  return (
    <MultiColumnList
      interactive={false}
      contentData={sectionFields}
      visibleColumns={[
        'label',
        'schema',
        'isRequired',
        'canEdit',
        'isRepeatable',
        'info',
      ]}
      columnWidths={{
        label: '30%',
        schema: '15%',
        isRequired: '15%',
        canEdit: '15%',
        isRepeatable: '15%',
        info: '10%',
      }}
      columnMapping={FieldsListColumnMapping}
      formatter={{
        label: (field) => fieldLabelFormatter(field),
        schema: (field) => schemaFormatter(field),
        isRequired: (field) => (
          <FormattedMessage
            id={`ui-plugin-inventory-templates.inventoryTemplates.${field.isRequired?.toString()}`}
            defaultMessage={field.isRequired?.toString()}
          />
        ),
        canEdit: (field) => (
          <FormattedMessage
            id={`ui-plugin-inventory-templates.inventoryTemplates.${field.canEdit?.toString()}`}
            defaultMessage={field.canEdit?.toString()}
          />
        ),
        isRepeatable: (field) => (
          <FormattedMessage
            id={`ui-plugin-inventory-templates.inventoryTemplates.${field.isRepeatable?.toString()}`}
            defaultMessage={field.isRepeatable?.toString()}
          />
        ),
        defaultValue: (field) => defaultValueFormatter(field),
        info: (field) => infoModalFormatter(field),
      }}
    />
  );
}

SectionFieldsList.propTypes = propTypes;

export default SectionFieldsList;
